import { appUrls } from "../../config/api-config/appUrls";
import { get, post } from "../../config/api-config/callMethods";
import { environment } from "../../config/environments/environment";
import axios from "axios";

export function authenticateByToken() {
    const url = environment.organizationSettingsApi + appUrls.organization.getAuthToken;
    return get(url);
}

export function refreshAuthToken(refreshTokenValue: string) {
    const url = environment.organizationSettingsApi + appUrls.organization.refreshAuthToken;
    const headers = {"Content-Type": "application/json" };
    return post(url, { refreshToken: refreshTokenValue },{headers: headers});
}